export enum AnswerTypeEnum
{
    NPS,
    Text,
    Number,
    Option,
    Formula
}

export enum FormulaOpetationEnum {
    "+",
    "-",
    "*",
    "/",
    "(",
    ")"
}

export enum QuestionOptionsOrientationEnum
{
    Horizontal,
    Vertical
}

export enum SurveyStatusEnum
{
    InDefinition,
    Programmed,
    InProgress,
    Finalized,
    Closed,
    Cancelled
}